import React, { FunctionComponent, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { InputLayout } from 'record-it-components/input/InputLayout/InputLayout';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { WorkTimeEntry } from '../../../classes/entities/WorkTimeEntry/workTimeEntryTypes';
import { useTimeTrackingActivityPathName } from '../../../hooks/entity/timeTrackingActivity/useTimeTrackingActivityPathName';

export type WorkTimeEntryActivityWidgetProps = PropsWithoutChildren<
  ComponentProps<'div'>
> & {
  workTimeEntry: WorkTimeEntry;
};

export const WorkTimeEntryActivityWidget: FunctionComponent<WorkTimeEntryActivityWidgetProps> =
  React.memo((props) => {
    const { workTimeEntry, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    const { t } = useTranslation();

    const pathName = useTimeTrackingActivityPathName(
      workTimeEntry.timeTrackingActivityId
    );

    return (
      <div {...remainingProps}>
        <InputLayout
          label={t('components.workTime.WorkTimeEntryActivityWidget.label')}
        >
          {() => (
            <div>
              {pathName ??
                t('components.workTime.WorkTimeEntryActivityWidget.noActivity')}
            </div>
          )}
        </InputLayout>
      </div>
    );
  });
